import React from 'react';


function Header({ children }) {
  return (
    <div className="header">
      <div className="header_alignment_container">
        {children}
      </div>
    </div>
  );
}

export default Header;